import { createFileRoute } from "@tanstack/react-router";

import { CommunityGuidelines } from "@/components/CommunityGuidelines";
import { createHead } from "@/components/createHead";
import { Page } from "@/components/Page";

export const Route = createFileRoute(
  "/_marketing-header-layout/community-guidelines",
)({
  component: RouteComponent,
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Community Guidelines | Graze",
      ogTitle: "Community Guidelines",
      description: "Community Guidelines for Graze.social",
      pathname,
      ogImage: "/community-guidelines.png",
    }),
});

function RouteComponent() {
  return (
    <Page className="md:max-w-240">
      <h1 className="text-4xl md:text-6xl font-bold instrument-serif">
        Community Guidelines
      </h1>
      <CommunityGuidelines />
    </Page>
  );
}
